import { Component } from '@angular/core';
import { CacLoginFormComponent } from '@controladad/ng-base';

@Component({
  selector: 'app-login',
  imports: [CacLoginFormComponent],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  logo = {
    url: '/assets/images/logo.jpg',
    alt: 'Kiek Logo'
  };
}
